import React from 'react';

const Services = () => {
  return (
    <div className="pt-20 pb-20 bg-ivory min-h-screen">
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-4xl font-serif font-bold mb-4 text-navy">Services</h1>
        <p className="font-sans text-navy/70">Individual service pages</p>
      </div>
    </div>
  );
};

export default Services;
